// Copyright (c) 2023 Deere & Company

import t from 'tcomb';

const DuplicatePinFormValidation = t.struct({
    address1: t.Bool,
    city: t.Bool,
    country: t.Bool,
    dateSubmmited: t.Bool,
    dealer: t.Bool,
    factory: t.Bool,
    machineModel: t.Bool,
    mailingRecipient: t.Bool,
    missingPlateReason: t.Bool,
    phone: t.Bool,
    pin: t.Bool,
    requesterTCSM: t.Bool,
    shippingId: t.Bool,
    state: t.Bool,
    zipCode: t.Bool

}, 'DuplicatePinFormValidation');

export const getDefaultState = () => new DuplicatePinFormValidation({
    address1: true,
    city: true,
    country: true,
    dateSubmmited: true,
    dealer: true,
    factory: true,
    machineModel: true,
    mailingRecipient: true,
    missingPlateReason: true,
    phone: true,
    pin: true,
    requesterTCSM: true,
    shippingId: true,
    state: true,
    zipCode: true
});

export default DuplicatePinFormValidation;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/state/duplicate-pin-form-validation.js